export default __webpack_public_path__ + "static/media/icon_texto.6ac7b7bf.svg";